import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/employees/pages/Settings/RootPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.employee_onboarding.path,
      element: <RootPage />,
      handle: {
        meta: () => {
          const meta = getSettingPageMeta(navigation, 'onboarding')
          return meta
        },
      },
    },
  ]
}

export default settingsRoutes
